/* Earthle analytics: only the approved Earthle project, after Shopify consent.
   No customer identifier, entered field value or order ID is sent. */
(() => {
  const config=document.querySelector('[data-earthle-clarity]');
  const project=config?.dataset.earthleClarity;
  if(!/^[a-z0-9]{6,20}$/.test(project||'')||window.earthleClarityInstalled)return;
  if(/[?&](preview_theme_id|earthle_concept|webPixelDebug)=/.test(location.search))return;
  if(/[?&](email|phone|customer|order|token|signature|hmac|checkout_token)=/i.test(location.search))return;
  if(/^\/(?:[a-z]{2}\/)?(?:account|challenge|orders)\b/.test(location.pathname))return;
  window.earthleClarityInstalled=true;
  let loaded=false,initialEvents=false,stopped=false;
  const privacy=()=>window.Shopify?.customerPrivacy;
  const allowed=()=>privacy()?.analyticsProcessingAllowed()===true&&privacy()?.currentVisitorConsent()?.analytics==='yes';
  function emit(name){if(loaded&&!stopped&&allowed())window.clarity('event',name);}
  function consent(){
    const granted=allowed();
    if(granted&&!loaded){
      loaded=true;
      window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
      window.clarity('consentv2',{analytics_Storage:'granted',ad_Storage:'denied'});
      document.querySelectorAll('[data-en-signup],[data-en-bis-form],[data-review-product],.shopify-forms-form').forEach(el=>el.setAttribute('data-clarity-mask','true'));
      const script=document.createElement('script');script.async=true;script.src='https://www.clarity.ms/tag/'+project;document.head.appendChild(script);
    }else if(loaded&&!stopped){
      window.clarity('consentv2',{analytics_Storage:granted?'granted':'denied',ad_Storage:'denied'});
      if(!granted){window.clarity('consent',false);window.clarity('stop');stopped=true;}
    }
    if(granted&&loaded&&!stopped&&!initialEvents){
      initialEvents=true;
      window.clarity('set','earthle_locale',document.documentElement.lang);
      window.clarity('set','earthle_event_source','storefront');
      if(document.body.classList.contains('template-product'))emit('earthle_product_view');
    }
  }
  document.addEventListener('visitorConsentCollected',consent);
  if(privacy())consent();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)consent();});
  // The theme dispatches this only after Shopify has accepted a cart add.
  document.addEventListener('ajaxProduct:added',()=>emit('earthle_cart_add'));
  document.addEventListener('submit',event=>{
    if(event.submitter?.name==='checkout'&&event.target.closest('#CartDrawerForm,#CartPageForm'))emit('earthle_checkout_start');
  },true);
})();
